export default "__VITE_ASSET__DxmL0PcS__"